import MissingImg from '@Img/illustration/missing-document.svg';

class MissingDocumentService {
	useMissingPreview (e: Event) {
		const target = e.target;
		if (target instanceof HTMLImageElement) {
			target.src = MissingImg;
			target.classList.add('missing-document-preview');
		}
	}
}

const missingDocumentServiceSingleton = new MissingDocumentService();

export default function useMissingDocumentService () {
	return missingDocumentServiceSingleton;
}
